import React, { createContext, useContext, useState, useMemo } from 'react';

const ReportesMetricsContext = createContext(null);

export const ReportesMetricsProvider = ({ children }) => {
    // Memoria RAM para Producción Mensual
    const [produccionMensualCache, setProduccionMensualCache] = useState(null);
    const [loadingProduccionMensual, setLoadingProduccionMensual] = useState(false);

    // Memoria RAM para Objetivos Sancor (almacena por ID de cuatrimestre)
    const [objetivosSancorCacheMap, setObjetivosSancorCacheMap] = useState({});
    const [loadingObjetivosSancor, setLoadingObjetivosSancor] = useState(false);

    const value = useMemo(() => ({
        produccionMensualCache,
        setProduccionMensualCache,
        loadingProduccionMensual,
        setLoadingProduccionMensual,
        
        objetivosSancorCacheMap,
        setObjetivosSancorCacheMap,
        loadingObjetivosSancor,
        setLoadingObjetivosSancor
    }), [
        produccionMensualCache, 
        loadingProduccionMensual, 
        objetivosSancorCacheMap, 
        loadingObjetivosSancor
    ]);

    return (
        <ReportesMetricsContext.Provider value={value}>
            {children}
        </ReportesMetricsContext.Provider>
    );
};

export const useReportesMetrics = () => {
    const context = useContext(ReportesMetricsContext);
    if (!context) {
        throw new Error("useReportesMetrics debe utilizarse dentro de un <ReportesMetricsProvider />");
    }
    return context;
};